import React from "react";
import Zumba from "../../../images/zumba.jpg";
import Musical from "../../../images/musical.jpg";
import KUJam from "../../../images/KindnessJam.jpg";
import Beats from "../../../images/BeatsKU.jpg";
import MusicNSPA from "../../../images/KUMusic-nspa.jpg";
import Dance from "../../../images/danceKU.jpg";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import CategoryCardGrid from "../../ui/CategoryCardGrid";

const artsCards = [
  { to: "./musical", image: Musical, title: "Musical for Fund-Raising" },
  { to: "./zumba", image: Zumba, title: "Zumba Session for Wheelchair Bound" },
  { to: "./kindnessjam", image: KUJam, title: "The Kindness Jam" },
  { to: "./beats", image: Beats, title: "Beats of a Kind" },
  { to: "./kindnessmusic", image: MusicNSPA, title: "Kindness in Music - NSPA" },
  { to: "./dancekindness", image: Dance, title: "Dance for Kindness" },
];

const Arts = () => (
  <PageLayout>
    <PageHero title="KU for Arts" light />
    <CategoryCardGrid cards={artsCards} columns={3} />
  </PageLayout>
);

export default Arts;
